(function () {
  if (window.RatnivaFooterAccordion) {
    window.RatnivaFooterAccordion.sync();
    return;
  }

  var mobileQuery = window.matchMedia('(max-width: 749px)');

  function syncFooterMenus() {
    var isMobile = mobileQuery.matches;
    var menus = document.querySelectorAll('[data-footer-menu-accordion]');

    menus.forEach(function (menu, index) {
      menu.open = isMobile ? index === 0 : true;
    });
  }

  function handleMenuToggle(event) {
    var activeMenu = event.target;
    if (!mobileQuery.matches || !activeMenu.open || !activeMenu.matches('[data-footer-menu-accordion]')) return;

    document.querySelectorAll('[data-footer-menu-accordion][open]').forEach(function (menu) {
      if (menu !== activeMenu) menu.open = false;
    });
  }

  window.RatnivaFooterAccordion = {
    sync: syncFooterMenus,
  };

  syncFooterMenus();
  document.addEventListener('shopify:section:load', syncFooterMenus);
  document.addEventListener('toggle', handleMenuToggle, true);

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener('change', syncFooterMenus);
  } else {
    mobileQuery.addListener(syncFooterMenus);
  }
})();
